export const ActionTypes = {
  LOADING: "SHARE_DECISION_LOADING",
  ERROR: "SHARE_DECISION_ERROR",
  SUCCESS: "SHARE_DECISION_SUCCESS",
};
